import { useMutation } from '@tanstack/react-query';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { downloadBlob } from '@common/utils/downloadBlob';
import { apiClient } from '@config/server/apiClient';
import { discountsEndpoints } from '@config/server/apiEndpoints';

/**
 * Export discounts request parameters
 */
export interface ExportDiscountsParams {
	discountIds?: string[];
}

/**
 * API function to export discounts as CSV
 * Downloads the file to the user's machine
 */
export const exportDiscounts = async (
	servicesProviderId: string,
	params: ExportDiscountsParams,
): Promise<void> => {
	const { discountIds } = params;

	const blob = await apiClient.postBlob(discountsEndpoints.export(servicesProviderId), {
		discountIds,
	});

	downloadBlob(blob, 'discounts.csv');
};

/**
 * Hook for exporting discounts as CSV
 */
export const useExportDiscounts = () => {
	const servicesProviderId = useCurrentServicesProviderId();

	return useMutation({
		mutationFn: async (params: ExportDiscountsParams) => {
			if (!servicesProviderId) {
				throw new Error('Cannot export discounts without services provider ID');
			}
			return exportDiscounts(servicesProviderId, params);
		},
	});
};
